export default __webpack_public_path__ + "static/media/Manuelle.7a769c54.png";